import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CanDeactivate, ActivatedRouteSnapshot } from '@angular/router';

import { StoryComponent } from '../components/story/story.component';
import { NotifyToStoryService } from './notify-to-story.service';
import { CoreDialogService } from '../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../Common/Dialogs/models/confirm-dialog.model';

export const canDeactivateGuardConstants: any = {
    confirmHeading: 'Unsaved Changes',
    confirmMessage: 'You have unsaved changes.<br />Are you sure you want to continue without saving?<br />All unsaved changes will be lost.',
    confirmMessageText: 'You have unsaved changes.\r\nAre you sure you want to continue without saving?\r\nAll unsaved changes will be lost.',
    continueLabel: 'Continue',
    cancelLabel: 'Cancel'
};

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<StoryComponent> {

    constructor(
        private notifyToStoryService: NotifyToStoryService,
        private coreDialogService: CoreDialogService
    ) { }

    canDeactivate(
        component: StoryComponent,
        route: ActivatedRouteSnapshot
    ): Observable<boolean> | boolean {

        if (!component.storyFormGroup || !component.isFormDirty()) {
            return true;
        }

        const subject = new Subject<boolean>();

        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: canDeactivateGuardConstants.confirmHeading,
                    messageHtml: canDeactivateGuardConstants.confirmMessage,
                    okLabel: canDeactivateGuardConstants.continueLabel,
                    cancelLabel: canDeactivateGuardConstants.cancelLabel
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            component.markFormPristine(component.storyFormGroup);
                            this.notifyToStoryService.emitDirtyStoryStatus(true);
                            this.notifyToStoryService.emitDirtyStoryId(0);
                            subject.next(true);
                            subject.complete();
                        } else {
                            this.notifyToStoryService.emitDirtyStoryStatus(false);
                            if (route.data.routeModel.isAmplified === true) {
                                this.notifyToStoryService.emitDirtyStoryId(0);
                            } else {
                                this.notifyToStoryService.emitDirtyStoryId(route.data.routeModel.storyId);
                            }
                            subject.next(false);
                            subject.complete();
                        }
                    }
                }
            }
        );

        return subject;
    }
}
